import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
// import {initialQueryState} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {Visitor} from '../../core/_models'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { useQueryResponsePagination } from '../../core/QueryResponseProvider'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<Visitor>>
}
const VisitorCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const pagination = useQueryResponsePagination()
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    // avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }

    if (!isSelectedForSorting) {
      // enable sort asc
      updateState({sort: id, order: 'asc', page: pagination.page, items_per_page: state.items_per_page})
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        // enable sort desc
        updateState({sort: id, order: 'desc', page: pagination.page, items_per_page: state.items_per_page})
        return
      }

      // disable sort
      updateState({sort: undefined, order: undefined, page: pagination.page, items_per_page: state.items_per_page})
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`
      )}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {title}
    </th>



  )
}

export {VisitorCustomHeader}
